import React from 'react';
import { useRef, useEffect, useState,useContext } from 'react';
import {  useParams } from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import {Buffer} from 'buffer';
import Card from 'react-bootstrap/Card';
import { AuthContext } from "../../context/authContext";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Map, {Marker} from 'react-map-gl';
import axios from 'axios'
import information from '../information/info2.json'
import Alert from 'react-bootstrap/Alert';

import { useNavigate } from "react-router-dom";
const MAPBOX_TOKEN ='pk.eyJ1Ijoic3R1ZGlncmFkIiwiYSI6ImNsZ25vN3JsazBoazUzbG9ldGlyYnZ0eGMifQ.dJHZGOO-SlBXr70pSXZ3iw';
const SERVER = `https://volunteer-server.onrender.com`
// const SERVER = `http://localhost:8800`
function Organization(props) {
    let { id } = useParams();
    const { currentUser,setCurrentUser } = useContext(AuthContext);
    const navigate = useNavigate();
    const [info,setInfo] = useState({name:'',information:[],punkts:[],img:[]})
    const [data, setData] = useState([]);
    const [error,serErr] = useState(true)
    const mapRef = useRef();
    const parseData = async()=>{
        try{
        const result = await axios.post(`${SERVER}/api/organization`,{id_organization:id});
        if(result.data.error){
            console.log(result.data.error)
            alert(result.data.error)
        }
        console.log(result.data[0])
        setData(result.data[0]);  
    }catch(e){
        console.log(e)
        alert(e)
        navigate('/')
    }
      }

      const find = ()=>{
        const result = information.find(element => 
             element.name == data.country
       );
     
         if(result == undefined){
             serErr(true)
           
         }else{
             serErr(false)
             setInfo(result)
         }
         
         
     }

      useEffect(() => {
        parseData()
        find()
      }, []);
      useEffect(() => {
  
        find()
      }, [data]);
      const deleteOrg = async()=>{
        try{
            const result = await axios.post(`${SERVER}/api/delete/organization`,{id_organization:id});
            if(result.data.error){
                console.log(result.data.error)
                alert(result.data.error)
            }
            alert("Organization deleted")
            navigate('/')
        }catch(e){
            alert(e)
            navigate('/')
        }
      }
    return (
        <div style={{height: '100%'}}>
             { (data.longitude && data.latitude) && 
              <Container fluid style={{height: '100%',marginTop:'2%'}} >
              <Row  style={{height: '500px',display:'flex'}} class="d-flex justify-content-center">
              <Col >
             
             <Map
            ref={mapRef}
            initialViewState={{
            longitude:data.longitude,
            latitude:data.latitude,
            zoom: 8
            }}
            style={{height: '100%',borderRadius: '5%',marginTop:'2%',  boxShadow: '1px 2px 9px #F4AAB9'}}
            mapStyle="mapbox://styles/mapbox/streets-v9"
            mapboxAccessToken= {MAPBOX_TOKEN}
             >;
       
          <Marker 
          longitude={data.longitude} 
          latitude={data.latitude} 
          anchor="bottom"  
          style={{cursor:'pointer'}}
          >
            </Marker>
            </Map>
        
        </Col>
        <Col style={{alignContent:"center",margin:"auto" }} >
        {/* <Alert key='secondary' variant='secondary'>
        {data.title}
            </Alert> */}
            <Card style={{ width: '100%',alignItems:"center" }} >
      <Card.Img variant="top" src={`data:${data.type};base64,${new Buffer(data.data).toString('base64')}`} style={{width:"50%",margin:'auto',marginTop:'2%'}}/>
      <Card.Body>
        <Card.Title>{data.title}</Card.Title>
        <Card.Text>
          {data.location}
        </Card.Text>
      </Card.Body>
    </Card>
        </Col>
         </Row>
         <Row style={{marginTop:'2%'}}>
        <Col style={{marginTop:'2%'}}> 
        <Alert key='primary' variant='primary'>
        {data.description}</Alert>
       </Col>
    
        </Row>
        { currentUser.category=="v" ? 
        <Row className="justify-content-md-center">
          <Col xs lg="2">
          <Col><Button variant="danger" onClick={deleteOrg}>ВИДАЛИТИ</Button></Col>
          </Col>
          <Col md="auto"></Col>
          <Col xs lg="2">
          <Col><Button variant="warning">ОНОВИТИ</Button></Col>
          </Col>
        </Row>
      : null }

            <h1>Інформація про документи для перевезення в {data.country}</h1>
    {info.information.map((el,ind)=>(
         <Row className="justify-content-md-center">
         <Col>
        
         <Card.Img  src={`https://www.pettravel.com/immigration/${info.img[ind]}`}  style={{width:"50%",marginLeft:'40%',marginTop:'10%'}}/> 

         </Col>
         <Col xs={10}>
                 <Card style={{ width: "100%" ,display:"flex"}}>
             <Card.Body>
               
                 <Card.Title>{ind+1}.{info.punkts[ind]} </Card.Title>
        
                 <Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>
                 <Card.Text>
                 {el}
                 </Card.Text>
                 <Card.Link href="#">Card Link</Card.Link>
                 <Card.Link href="#">Another Link</Card.Link>
             </Card.Body>
            
             </Card>
        </Col>
       </Row>
    ))}
     

     















        </Container>

        
    }
         
              

       
        </div>
    );
}

export default Organization;